// extracted by mini-css-extract-plugin
export default {"container":"AddNewForm_container__rvO5J","body":"AddNewForm_body__uBg+C","headerRow":"AddNewForm_headerRow__q9vEd","dateRow":"AddNewForm_dateRow__yg6Jl"};